export const sortNullable = (a: number | null, b: number | null) => {
  if (b !== null && a !== null) {
    return b - a;
  }
  if (b === null && a !== null) {
    return -1;
  }
  if (b !== null && a === null) {
    return 1;
  }

  return 0;
};

export const sortBy =
  <T, K extends keyof T>(key: K, order: 'asc' | 'desc' = 'asc') =>
  (a: T, b: T) => {
    if (order === 'asc') {
      return a[key] > b[key] ? 1 : -1;
    }

    return a[key] < b[key] ? 1 : -1;
  };

export const findMaxBy = <T, K extends keyof T>(
  items: T[],
  key: K
): T | undefined => {
  return items.reduce<T | undefined>((max, item) => {
    if (!max) {
      return item;
    }

    return item[key] > max[key] ? item : max;
  }, undefined);
};

export const partition = <T>(
  array: readonly T[],
  size: number
): readonly T[][] => {
  if (array.length === 0) return [];
  return [array.slice(0, size), ...partition(array.slice(size), size)];
};
